<template>
  <van-popup :show="show" :lock-scroll="true" :close-on-click-overlay="false" :z-index="3000"
    class="banned-dialog-popup" round @update:show="handleUpdateShow" @closed="emit('closed')">
    <div class="dialog-content">
      <!-- 标题 -->
      <div v-if="title" class="dialog-title">{{ title }}</div>

      <!-- 内容 -->
      <div v-if="tips" class="dialog-body">
        <div class="dialog-tips">
          {{ tips }}
        </div>
        <!-- 额外提示 -->
        <div v-if="extra || unbanTime" class="dialog-extra">
          <span v-if="extra">{{ extra }}</span>
          <span v-if="unbanTime">
            {{ formattedDuration(remaining).formatStr }}
          </span>
        </div>
      </div>

      <!-- 按钮 -->
      <button class="dialog-button" @click="handleConfirm">
        {{ buttonContent || $t('common.confirm') }}
      </button>
    </div>
  </van-popup>
</template>

<script setup>
import { onBeforeUnmount, watch } from 'vue'
import { useCountdown } from '@vueuse/core'
import { formattedDuration } from '@/utils/date'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  tips: {
    type: String,
    default: ''
  },
  extra: {
    type: String,
    default: ''
  },
  buttonContent: {
    type: String,
  },
  unbanTime: {
    type: Number,
    default: 0
  }
})
const emit = defineEmits(['closed', 'update:show', 'close', 'confirm'])

// 使用 useCountdown 进行倒计时，通过 watch 控制
const { remaining, stop, start } = useCountdown(0, {
  onComplete: () => {
    window.location.reload()
  }
})

const handleUpdateShow = (value) => {
  emit('update:show', value)
}

const handleConfirm = () => {
  emit('confirm')
}

onBeforeUnmount(() => {
  stop()
})

watch(() => props.show, (newShow) => {
  if (newShow && props.unbanTime) {
    const now = Math.floor(Date.now() / 1000) // 当前时间戳（秒）
    const remainingSeconds = props.unbanTime - now
    start(remainingSeconds)
  }
})
</script>

<style lang="less" scoped>
.banned-dialog-popup {
  width: 295px;
  background: #FFF;
  padding: 28px 24px 20px;

  .dialog-content {
    width: 100%;
  }

  .dialog-title {
    color: #2B2D42;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .dialog-body {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .dialog-tips {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #636778;
      text-align: center;
      white-space: pre-wrap;
      word-break: break-word;
    }

    .dialog-extra {
      color: #FF0100;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }


  .dialog-button {
    width: 100%;
    height: 48px;
    background: linear-gradient(141deg, #C764FF 3.02%, #7F4AFF 96.08%);
    border-radius: 47px;
    color: #FFF;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
